import produce from 'immer';

import {
    GET_SELF_DATA_REQUEST,
    GET_SELF_DATA_SUCCESS,
    GET_SELF_DATA_FAIL,
    GET_REPORT_DATA_REQUEST,
    GET_REPORT_DATA_SUCCESS,
    GET_REPORT_DATA_FAIL,
    GET_USER_ATTEMPTS_REQUEST,
    GET_USER_ATTEMPTS_SUCCESS,
    GET_USER_ATTEMPTS_FAIL
} from "./constants";

export const initialState = {
    isLoading: false,
    datas: [],
    reportData: [],
    error: false,
    userAttempts: [],
    userAttemptsLoading: false,
    userAttemptsError: null,
};

const hazmatReducer = (state = initialState, {type, payload}) =>
    produce(state, draft => {
        switch (type) {
            case GET_SELF_DATA_REQUEST:
                draft.isLoading = true;
                draft.datas = [];
                draft.error = false;
                break;
            case GET_SELF_DATA_SUCCESS:
                draft.isLoading = false;
                draft.datas = payload;
                break;
            case GET_SELF_DATA_FAIL:
                draft.isLoading = false;
                draft.error = payload;
                break;
            case GET_REPORT_DATA_REQUEST:
                draft.isLoading = true;
                draft.reportData = [];
                draft.error = false;
                break;
            case GET_REPORT_DATA_SUCCESS:
                draft.isLoading = false;
                draft.reportData = payload;
                break;
            case GET_REPORT_DATA_FAIL:
                draft.isLoading = false;
                draft.error = payload;
                break;
            case GET_USER_ATTEMPTS_REQUEST:
                draft.userAttemptsLoading = true;
                draft.userAttemptsError = null;
                break;
            case GET_USER_ATTEMPTS_SUCCESS:
                draft.userAttemptsLoading = false;
                draft.userAttempts = payload;
                break;
            case GET_USER_ATTEMPTS_FAIL:
                draft.userAttemptsLoading = false;
                draft.userAttemptsError = payload;
                break;
            default:
                break;
        }
    });

export default hazmatReducer;